import { Component, OnInit } from "@angular/core";
import {
  DatabaseCacheService,
  Section,
  Breadcrumb,
} from "../../../data/cache/database-cache.service";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.css"],
  imports: SHARED_IMPORTS,
})
export class NotFoundComponent implements OnInit {
  firstSection: Section | null = null;
  hasSections = false;

  constructor(private common: DatabaseCacheService) {}

  ngOnInit() {
    const sections = this.common.getSectionDocuments() || [];
    this.hasSections = sections.length > 0;
    this.firstSection = this.hasSections ? sections[0] : null;
  }
}
